'use strict';
const assert = require('assert');
const Offers = require('../offers');
const chai = require('chai');
const sdkConfiguration = require('../../configurations/sdk-configuration');

const credentials = {
  domain: 'csDesarrollo.onmicrosoft.com',
  clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
  userName: 'app@csDesarrollo.onmicrosoft.com',
  password: 'Inn0vaci0n',
};
const fakeOfferId = '221123456789';
const fakeRequest = options => Promise.resolve(options);

const expect = chai.expect;
/* eslint-disable no-undef, no-unused-vars */
describe('Offers', () => {
  it('Creates a correct instance of the class', (done) => {
    const offers = new Offers(credentials, fakeRequest, sdkConfiguration);
    expect(offers).to.have.property('requestManager');
    expect(offers.requestManager).to.have.property('requestConfigurationManager');
    expect(offers.requestManager).to.have.property('authConfiguration');
    expect(offers.requestManager.requestConfigurationManager).to.have.property('sdkConfiguration');
    expect(offers.requestManager.requestConfigurationManager).to.have.property('credentials');
    expect(offers.requestManager.requestConfigurationManager).to.have.property('request');
    expect(offers).to.have.property('paramsManager');
    expect(offers.paramsManager).to.have.property('pathParams');
    expect(offers.paramsManager).to.have.property('bodyParams');
    expect(offers.paramsManager).to.have.property('queryParams');
    done();
  });
  it('get, all the subscriptions by country code', (done) => {
    const offers = new Offers(credentials, fakeRequest, sdkConfiguration);
    offers.byCountryCode('MX').get().then((offersList) => {
      assert(offersList.method === 'GET');
      assert(offersList.uri === 'https://api.partnercenter.microsoft.com/v1/offers?country=MX');
      assert(offersList.headers.Accept === 'application/json');
      assert(offersList.headers['Content-Type'] === 'application/json');
      expect(offersList.headers).to.have.property('MS-RequestId');
      expect(offersList.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('get, if country code is not set, return an error', (done) => {
    const offers = new Offers(credentials, fakeRequest, sdkConfiguration);
    try {
      offers.get();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byCountryCode function, to set the country');
      done();
    }
  });
  it('get, specific offer details', (done) => {
    const offers = new Offers(credentials, fakeRequest, sdkConfiguration);
    offers.byCountryCode('MX').byId(fakeOfferId).get().then((offersList) => {
      assert(offersList.method === 'GET');
      assert(offersList.uri === 'https://api.partnercenter.microsoft.com/v1/offers/221123456789?country=MX');
      assert(offersList.headers.Accept === 'application/json');
      assert(offersList.headers['Content-Type'] === 'application/json');
      expect(offersList.headers).to.have.property('MS-RequestId');
      expect(offersList.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('getCategories, get all the categories', (done) => {
    const offers = new Offers(credentials, fakeRequest, sdkConfiguration);
    offers.byCountryCode('MX').getCategories().then((offersCategories) => {
      assert(offersCategories.method === 'GET');
      assert(offersCategories.uri === 'https://api.partnercenter.microsoft.com/v1/offercategories?country=MX');
      assert(offersCategories.headers.Accept === 'application/json');
      assert(offersCategories.headers['Content-Type'] === 'application/json');
      expect(offersCategories.headers).to.have.property('MS-RequestId');
      expect(offersCategories.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('getCategories, if country code is not set, return an error', (done) => {
    const offers = new Offers(credentials, fakeRequest, sdkConfiguration);
    try {
      offers.getCategories();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byCountryCode function, to set the country');
      done();
    }
  });
  it('getAddOns, get all the addons for an offer', (done) => {
    const offers = new Offers(credentials, fakeRequest, sdkConfiguration);
    offers.byCountryCode('MX').byId(fakeOfferId).getAddons().then((AddOns) => {
      assert(AddOns.method === 'GET');
      assert(AddOns.uri === 'https://api.partnercenter.microsoft.com/v1/offers/221123456789/addons?country=MX');
      assert(AddOns.headers.Accept === 'application/json');
      assert(AddOns.headers['Content-Type'] === 'application/json');
      expect(AddOns.headers).to.have.property('MS-RequestId');
      expect(AddOns.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('getAddons, if country code is not set, return an error', (done) => {
    const offers = new Offers(credentials, fakeRequest, sdkConfiguration);
    try {
      offers.getAddons();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byCountryCode function, to set the country');
      done();
    }
  });
  it('getAddons, if offerId is not set return an error', (done) => {
    const offers = new Offers(credentials, fakeRequest, sdkConfiguration);
    try {
      offers.byCountryCode('MX').getAddons();
    } catch (error) {
      assert(error.message === 'To use this function, first use the byId function, to set the offerId');
      done();
    }
  });
});
